import {
  VTooltip,
} from 'v-tooltip';
import Vue from 'vue';
import App from './App.vue';
import store from './store';
import router from './router';

Vue.config.productionTip = false;

VTooltip.options = {
  ...VTooltip.options,

  defaultOffset: 8,
  defaultPlacement: 'top-start',
};

Vue.directive('tooltip', VTooltip);

new Vue({
  store,
  router,
  render: h => h(App),
}).$mount('#app');
